module.exports = __webpack_public_path__ + "static/FSRIwordmarkBlue-528d724caafc5896174f5c2c547b69da.png";